export default "__VITE_ASSET__DszuEsrg__"